// @flow
import type { StripeToken } from "./types"
import { stripeCardFunding } from "./constants"

/**
 * Checks if a given card is prepaid
 * @param {StripeToken} token - The card token returned from the Stripe API
 * @returns {boolean} - true if is a prepaid card
 */
export const isPrepaid = (token: StripeToken): boolean =>
  token.card.funding === stripeCardFunding.prepaid



// WEBPACK FOOTER //
// ./src/data/stripe/helpers.js